import React from 'react'
import _ from 'lodash';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
export default function GatewayWhiteListedRoutesInfoComponent ({handleFormWhitelistedRoutesItemChange,whitelistedRoutes}: any) {
  return (
    <>
      <div className="h-[500px] overflow-auto w-full bg-white p-4">
        <table className="w-full text-xs bg-red-50">
          <thead className="w-full border-y border-black border-opacity-20">
            <tr className="w-full text-left h-12">
              <th className="border-r-2  last:border-r-0 w-auto px-10">Id</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">Name</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">Value</th>
            </tr>
          </thead>
          <tbody className="w-full bg-red-400 h-[400px]">
            {_.map(whitelistedRoutes,(cardValue: any, index: any) => (
              <tr key={index} className="w-full cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
               
                  <td 
                  className="px-6 py-4  w-auto">
                  {index+1}           
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  <InputContainer
isDisabled
     
      name="Name"
      onValueChange={(event: any) => {
        handleFormWhitelistedRoutesItemChange({
          value: event.target.value,
          field: 'Name',
          idx: index
        });
      } }
      type="text"
      value={cardValue?.Name} />
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  <InputContainer
isDisabled
  
                                    name="Value"
                                    onValueChange={(event: any) => {
                                      handleFormWhitelistedRoutesItemChange({
                                        value: event.target.value,
                                        field: 'Value',
                                        idx: index
                                      });
                                    } }
                                    type="text"
                                    value={cardValue?.Value} />
                  </td>
                  <td 
                  className="px-6 py-4  w-auto">
                  </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
        </>
  )
}